import type { HelpContent, HelpRole, HelpSection } from './content/types';

export interface OrderedGroup {
  id: string;
  title: string;
  sections: HelpSection[];
}

/**
 * The contents in the reader's order: inside each group, sections written for the reader's role
 * come first (then the guide's order); groups whose sections are all for other roles move after the
 * rest. Nothing is hidden — an executive can still read the manager sections.
 */
export function orderForRole(content: HelpContent, role: HelpRole | null): OrderedGroup[] {
  const byId = new Map(content.sections.map((s) => [s.id, s]));
  const forMe = (s: HelpSection) => (role ? s.roles.includes(role) : true);
  const groups = content.groups.map((g, gi) => {
    const sections = g.sections
      .map((id, i) => ({ s: byId.get(id), i }))
      .filter((x): x is { s: HelpSection; i: number } => !!x.s)
      .sort((a, b) => Number(forMe(b.s)) - Number(forMe(a.s)) || a.i - b.i)
      .map((x) => x.s);
    return { id: g.id, title: g.title, sections, gi, mine: sections.some(forMe) };
  });
  return groups
    .filter((g) => g.sections.length)
    .sort((a, b) => Number(b.mine) - Number(a.mine) || a.gi - b.gi)
    .map(({ id, title, sections }) => ({ id, title, sections }));
}
